import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { InvestorProfileData } from "../../../components/Models/InvestorProfileData";

interface useGetTermsRequestsProps {
  userId: string;
  enabled?: boolean;
}

export function useGetInvestorDetails({
  userId,
  enabled = true,
}: useGetTermsRequestsProps) {
  return useQuery({
    enabled,
    queryKey: ["investor-data", userId],
    queryFn: async () => {
      return axiosInstance<InvestorProfileData[]>(
        getAPIURL(`/MuslimInvestProfile/Investor/by-user/${userId}`)
      ).then((response) => response.data);
    },
  });
}
